import React, { ChangeEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import IDeleteUser from '../../interfaces/IDeleteUser';
import { deleteUsers } from '../../services/users';
import { getValidationNumbers } from '../../utils/numbers';
import SystemModal from '../../common/SystemModal';

interface IProps {
  usersList: IDeleteUser[];
  modalIsOpen: boolean;
  onClose(deleted: boolean): void;
  showSnackBar(message: string, type: string): void;
}

const ModalConfirmDelete = ({ usersList, modalIsOpen, onClose, showSnackBar }: IProps): JSX.Element => {
  const { t: translate } = useTranslation();
  const [inputValue, setInputValue] = useState('');
  const [validationNumbers, setValidationNumbers] = useState<number[]>(getValidationNumbers());
  const [firstNumber, secondNumber] = validationNumbers;
  const validationResult = firstNumber + secondNumber;

  useEffect(() => {
    setValidationNumbers(getValidationNumbers());
    if (!modalIsOpen) {
      setInputValue('');
    }
  }, [usersList, modalIsOpen]);

  const onConfirm = async () => {
    try {
      await deleteUsers(usersList);
      showSnackBar(translate('notification/success_delete_users'), 'success');
      onClose(true);
    } catch (error) {
      showSnackBar(String(error), 'error');
      console.error(error);
    }
  };

  const _onClose = () => {
    onClose(false);
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  return (
    <SystemModal modalIsOpen={modalIsOpen} onRequestClose={_onClose}>
      <section className="modal-content modal-delete-registers">
        <header>
          <h2 className="modal-title">{translate('modal/exclude_info_title')}</h2>
        </header>
        <div className="modal-section-content">
          <p>
            {translate('modal/exclude_info_text')}
            <strong className="text-uppercase">{translate('modal/exclude_info_text1')}</strong>
            {translate('modal/exclude_info_text2')}
          </p>
          <p className="text-bold">
            {translate('modal/exclude_total_selected')} {usersList.length}
          </p>
          <label className="text-bold">
            {translate('modal/resolve_sum_text')} {firstNumber}+{secondNumber}?
          </label>
          <input value={inputValue} className="form-control" onChange={handleChange} />
        </div>
        <footer>
          <button type="button" onClick={_onClose} className="btn-white-green">
            {translate('modal/exclude_cancel')}
          </button>
          <button
            type="button"
            id="btnConfirm"
            onClick={onConfirm}
            disabled={parseInt(inputValue) !== validationResult}
            className="btn-green">
            {translate('modal/exclude_confirm')}
          </button>
        </footer>
      </section>
    </SystemModal>
  );
};

export default ModalConfirmDelete;
